import axios from "axios";
import { datadogRum } from "@datadog/browser-rum";
import { drw_endpoint_url } from "./api";
import { CreateCouponForPepRequestPayload } from "../features/Coupons/actions";
import { DeviceType } from "../features/Coupons/types";

export type RequestCouponForPEPResponse = {
  deviceType: DeviceType;
  couponPrecursor: string;
};

export async function requestCouponForPep(
  data: CreateCouponForPepRequestPayload
): Promise<RequestCouponForPEPResponse> {
  try {
    datadogRum.addAction("[requestCouponForPEP] Creating PEP coupon", data);
    return await axios.post(`${drw_endpoint_url}/api/coupon/createPEPCoupon`, data);
  } catch (e) {
    datadogRum.addError(new Error("[requestCouponForPEP] Failed to create PEP coupon"), { error: e, ...data });
    throw e;
  }
}
